import {
  Directive,
  forwardRef,
} from '@angular/core'
import {
  UntypedFormControl,
  NG_VALIDATORS,
} from '@angular/forms'

export function validateEmailList(c: UntypedFormControl) {
  const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i
  let result = false
  if (c.value) {
    const emails = c.value.split(',').map(email => email.trim())
    result = emails.every((email) => EMAIL_REGEXP.test(email))
  }
  return result ? null : {
    validateEmailList: {
      valid: false
    }
  }
}

@Directive({
  selector: '[validateEmailList][ngModel],[validateEmailList][formControl]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => EmailListValidator), multi: true }
  ]
})
export class EmailListValidator {
  validator: Function = validateEmailList

  constructor() {}

  validate(c: UntypedFormControl) {
    return this.validator(c)
  }
}
